export const GITHUB_OWNER = 'charlite';

export const GITHUB_ORG_URL = `https://github.com/${GITHUB_OWNER}`;

export const GITHUB_PROFILE_URL = `https://github.com/${GITHUB_OWNER}`;

export const GITHUB_REPO = 'charlite/email-signature-editor';

export const GITHUB_REPO_URL = `https://github.com/${GITHUB_REPO}`;

export const GITHUB_LICENSE_URL = `${GITHUB_REPO_URL}/blob/main/LICENSE`;

export const GITHUB_CONTRIBUTING_URL = `${GITHUB_REPO_URL}/blob/main/CONTRIBUTING.md`;

export const GITHUB_SECURITY_URL = `${GITHUB_REPO_URL}/blob/main/SECURITY.md`;
